export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_brandName') || '品牌名称',
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_modifyInfo') || '数据更新',
    field: 'modifyInfo',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
